import React from "react";
import styles from "./ConversationChannelIcon.module.css";
import {ConversationChannel} from "../../../api/generated";

interface ConfirmationModalProps {
    conversationChannel: ConversationChannel
}

export const ConversationChannelIcon: React.FC<ConfirmationModalProps> = ({
                                                                              conversationChannel
                                                                          }) => {

    const getIconsSrc = (): string[] => {
        switch (conversationChannel) {
            case ConversationChannel.Widget:
                return ["/pinkWithBlackLogo.svg"]
            case ConversationChannel.SuperchatEmail:
                return ["/superchatLogo.svg", "/emailIcon.svg"]
            case ConversationChannel.SuperchatFacebook:
                return ["/superchatLogo.svg", "/facebookLogo.svg"]
            case ConversationChannel.SuperchatInstagram:
                return ["/superchatLogo.svg", "/instagramLogo.svg"]
            case ConversationChannel.SuperchatSms:
                return ["/superchatLogo.svg", "/smsLogo.png"]
            case ConversationChannel.SuperchatTelegram:
                return ["/superchatLogo.svg", "/telegramLogo.svg"]
            case ConversationChannel.SuperchatWhatsApp:
                return ["/superchatLogo.svg", "/whatsAppLogo.svg"]
            case ConversationChannel.ContactCenterWhatsApp:
                return ["/contactCenterLogo.svg", "/whatsAppLogo.svg"]
            case ConversationChannel.ContactCenterEmail:
                return ["/contactCenterLogo.svg", "/emailIcon.svg"]
            case ConversationChannel.ContactCenterSms:
                return ["/contactCenterLogo.svg", "/smsLogo.png"]
            case ConversationChannel.ConfidentAi:
                return ["/confidentAiLogo.jpeg"]
            default:
                throw new Error(`Unsupported ConversationChannel: ${conversationChannel}`)
        }
    }

    const iconsSrc = getIconsSrc()

    return <div className={styles.wrapper}>
        {iconsSrc.map((src: string, index: number) => {
            return <div className={styles.iconWrapper}>
                {index !== 0 && "+"}
                <img
                    key={index}
                    className={styles.icon}
                    src={src}
                    alt={"icon"}
                />
            </div>
        })}
    </div>
};
